import consumer from "./consumer"

// Function to create and show the notification popdown
function initSalesforceRefreshNotification(orderId) {
  // Create the notification container if it doesn't exist
  let notification = document.getElementById('salesforce-refresh-notification');

  if (!notification) {
    console.log("Creating notification UI");
    notification = document.createElement('div');
    notification.id = 'salesforce-refresh-notification';
    notification.className = 'salesforce-notification';
    notification.innerHTML = `
      <div class="notification-header">
        <span class="notification-title">Salesforce Sync Progress</span>
        <button class="notification-close" onclick="closeSalesforceNotification()">&times;</button>
      </div>
      <div class="notification-body" id="salesforce-notification-body">
      </div>
    `;
    document.body.appendChild(notification);

    // Show the notification
    setTimeout(() => {
      notification.classList.add('show');
    }, 100);
  }

  return notification;
}

// Function to add a message to the notification
function addNotificationMessage(message, type = 'info') {
  const body = document.getElementById('salesforce-notification-body');
  if (body) {
    const messageDiv = document.createElement('div');
    messageDiv.className = `notification-message notification-${type}`;
    messageDiv.textContent = message;
    body.appendChild(messageDiv);

    // Auto-scroll to the bottom
    body.scrollTop = body.scrollHeight;
  }
}

// Function to close the notification
window.closeSalesforceNotification = function() {
  const notification = document.getElementById('salesforce-refresh-notification');
  if (notification) {
    notification.classList.remove('show');
    setTimeout(() => {
      notification.remove();
    }, 300);
  }
}

// Wire the "Resync from Salesforce" button so it gives immediate feedback and
// reloads on completion WITHOUT depending on the websocket. The synchronous
// controller action returns a JS redirect that rails-ujs evaluates, so the page
// reloads (with a server-set flash) whether or not /cable is reachable. The cable
// progress popup is just a bonus when the socket connects. Bound per-element (the
// button is recreated on every turbolinks load) and guarded so a module re-eval
// can't double-bind it.
function setupResyncButton(orderId) {
  const btn = document.getElementById('resync-salesforce-btn');
  if (!btn || btn._resyncBound) return;
  btn._resyncBound = true;

  btn.addEventListener('ajax:send', function() {
    initSalesforceRefreshNotification(orderId);
    addNotificationMessage('Starting Salesforce refresh… this can take up to a minute. The page will reload when it finishes.', 'info');
    btn.classList.add('disabled');
    btn.setAttribute('aria-disabled', 'true');
    if (!btn.dataset.origText) btn.dataset.origText = btn.textContent;
    btn.textContent = 'Resyncing…';
  });

  // Success returns a JS redirect that rails-ujs runs (page reloads), so we only
  // need to handle failures: a 500 isn't auto-evaluated, so reload anyway to show
  // the server-set flash explaining what went wrong.
  btn.addEventListener('ajax:error', function() {
    addNotificationMessage('Refresh request failed — reloading to show the status…', 'error');
    setTimeout(function() { window.location.reload(); }, 1000);
  });

  btn.addEventListener('ajax:complete', function() {
    btn.classList.remove('disabled');
    btn.removeAttribute('aria-disabled');
    if (btn.dataset.origText) btn.textContent = btn.dataset.origText;
  });
}

function handleSfRefreshTurbolinksLoad() {
  const orderElement = document.querySelector('[data-order-id]');
  if (!orderElement) return;

  const orderId = orderElement.dataset.orderId;
  console.log("Order page detected, order ID:", orderId);

  setupResyncButton(orderId);

  // Drop any leftover subscription before making a new one
  if (window.salesforceRefreshSubscription) {
    window.salesforceRefreshSubscription.unsubscribe();
    window.salesforceRefreshSubscription = null;
  }

  const subscription = consumer.subscriptions.create(
    { channel: "SalesforceRefreshChannel", order_id: orderId },
    {
      connected() {
        console.log("✓ Connected to SalesforceRefreshChannel for order " + orderId);
      },

      disconnected() {
        console.log("✗ Disconnected from SalesforceRefreshChannel");
      },

      received(data) {
        console.log("📨 Received data:", data);

        if (data.message) {
          let notification = document.getElementById('salesforce-refresh-notification');
          if (!notification) {
            initSalesforceRefreshNotification(orderId);
          }

          addNotificationMessage(data.message, data.type || 'info');

          if (data.completed) {
            setTimeout(() => {
              window.closeSalesforceNotification();
              window.location.reload();
            }, 3000);
          }
        }
      }
    }
  );

  window.salesforceRefreshSubscription = subscription;
}

function handleSfRefreshTurbolinksBeforeCache() {
  if (window.salesforceRefreshSubscription) {
    window.salesforceRefreshSubscription.unsubscribe();
    window.salesforceRefreshSubscription = null;
  }

  const notification = document.getElementById('salesforce-refresh-notification');
  if (notification) {
    notification.remove();
  }
}

// Dedupe across module re-evaluations so handlers don't stack on repeated navigations
if (window._sfRefreshLoadHandler) {
  document.removeEventListener('turbolinks:load', window._sfRefreshLoadHandler);
}
if (window._sfRefreshBeforeCacheHandler) {
  document.removeEventListener('turbolinks:before-cache', window._sfRefreshBeforeCacheHandler);
}
window._sfRefreshLoadHandler = handleSfRefreshTurbolinksLoad;
window._sfRefreshBeforeCacheHandler = handleSfRefreshTurbolinksBeforeCache;
document.addEventListener('turbolinks:load', window._sfRefreshLoadHandler);
document.addEventListener('turbolinks:before-cache', window._sfRefreshBeforeCacheHandler);
